import { EndPoint } from '@/constant/api/ApiConstants'
import axios from 'axios'

export const submitFnol = (data: any): Promise<any> => {
    const baseUrl = process.env.VUE_APP_KYOEI_BACKEND_BASE_URL
    const authKey = process.env.VUE_APP_KYOEI_BACKEND_X_AUTH_KEY
    const headers = { 'X-Auth-Key': authKey }
    return axios.post(baseUrl + EndPoint.SUBMIT_FNOL, data, { headers })
}
